import { AppBar as MuiAppBar, Toolbar, Typography, IconButton, Box, useTheme } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useSettingsStore } from '../../stores/settingsStore';

interface AppBarProps {
  onSettingsClick: () => void;
  isMobile?: boolean;
}

const AppBar = ({ onSettingsClick, isMobile = false }: AppBarProps) => {
  const isDark = useTheme().palette.mode === 'dark';
  const updateThemeMode = useSettingsStore((state) => state.updateThemeMode);

  return (
    <MuiAppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: '100vw',
        left: 0,
        right: 0,
        // Flutter-style AppBar - flat, no gradient; background comes from the theme override
        boxShadow: 'none',
        height: isMobile ? 56 : 64,
      }}
    >
      <Toolbar 
        sx={{ 
          maxWidth: '100%', 
          px: { xs: 2, sm: 3, md: 4 },
          minHeight: isMobile ? 56 : 64,
        }}
      >
        <Typography 
          variant={isMobile ? "h6" : "h5"} 
          component="div" 
          sx={{ 
            flexGrow: 1,
            fontWeight: 500,
            fontSize: isMobile ? '1.25rem' : '1.5rem',
            color: 'primary.contrastText',
          }}
        >
          Live Shuffle
        </Typography>
        
        {!isMobile && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mr: 2 }}>
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.9)',
                fontWeight: 400,
              }}
            >
              Live Music Streaming
            </Typography>
          </Box>
        )}
        
        <IconButton
          color="inherit"
          onClick={() => updateThemeMode(isDark ? 'light' : 'dark')}
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          sx={{
            color: 'rgba(255, 255, 255, 0.9)',
            '&:hover': {
              color: '#ffffff',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
        >
          {isDark ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>

        <IconButton
          color="inherit"
          onClick={onSettingsClick}
          aria-label="Settings"
          sx={{
            color: 'rgba(255, 255, 255, 0.9)',
            '&:hover': {
              color: '#ffffff',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
        >
          <SettingsIcon />
        </IconButton>
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
